// src/utils/jurisdictionData.js

export const JURISDICTION_GROUPS = [
    {
        county: "Santa Clara",
        state: "CA",
        color: "bg-blue-400",
        glow: "shadow-blue-400/20",
        text: "text-blue-200",
        cities: [
            // "Los Altos",
            "Los Altos Hills",
            // "Palo Alto",
            // "Saratoga",
            // "Los Gatos",
            // "Monte Sereno",
            // "Cupertino",
            // "Cupertino Hillside",
            // "San Jose",
            // "Mountain View",
            // "Sunnyvale",
            // "Santa Clara",
            // "Milpitas",
            // "Campbell",
            // "Gilroy",
            // "Morgan Hill"
        ]
    },
    /*
    {
        county: "Alameda",
        state: "CA",
        color: "bg-rose-400",
        glow: "shadow-rose-400/20",
        text: "text-rose-200",
        cities: [
            "Oakland",
            "Alameda",
            "Berkeley",
            "Hayward",
            "Livermore",
            "Pleasanton",
            "Dublin",
            "Newark",
            "Union City",
            "San Leandro",
            "Emeryville",
            "Albany",
            "Piedmont",
            "Fremont"
        ]
    },
    {
        county: "San Mateo",
        state: "CA",
        color: "bg-indigo-400",
        glow: "shadow-indigo-400/20",
        text: "text-indigo-200",
        cities: [
            "Hillsborough",
            "Atherton",
            "Woodside",
            "Redwood City",
            "San Mateo",
            "Daly City",
            "South San Francisco",
            "Foster City",
            "Burlingame",
            "Belmont",
            "San Carlos",
            "Menlo Park",
            "Millbrae",
            "Pacifica",
            "Half Moon Bay",
            "Portola Valley"
        ]
    },
    {
        county: "Contra Costa",
        state: "CA",
        color: "bg-amber-400",
        glow: "shadow-amber-400/20",
        text: "text-amber-200",
        cities: [
            "Orinda",
            "Lafayette",
            "Walnut Creek",
            "Concord",
            "Richmond",
            "Antioch",
            "Brentwood",
            "Pittsburg",
            "San Ramon",
            "Pleasant Hill",
            "Martinez",
            "El Cerrito",
            "Hercules",
            "Pinole",
            "Clayton",
            "Oakley",
            "San Pablo",
            "Moraga",
            "Danville",
            "Alamo"
        ]
    },
    {
        county: "Marin",
        state: "CA",
        color: "bg-emerald-400",
        glow: "shadow-emerald-400/20",
        text: "text-emerald-200",
        cities: [
            "Belvedere",
            "Corte Madera",
            "Fairfax",
            "Larkspur",
            "Mill Valley",
            "Novato",
            "Ross",
            "San Anselmo",
            "San Rafael",
            "Sausalito",
            "Tiburon"
        ]
    },
    {
        county: "Napa",
        state: "CA",
        color: "bg-amber-500",
        glow: "shadow-amber-500/20",
        text: "text-amber-100",
        cities: [
            "American Canyon",
            "Calistoga",
            "Napa",
            "St. Helena",
            "Yountville"
        ]
    },
    {
        county: "Solano",
        state: "CA",
        color: "bg-rose-500",
        glow: "shadow-rose-500/20",
        text: "text-rose-100",
        cities: [
            "Benicia",
            "Dixon",
            "Fairfield",
            "Rio Vista",
            "Suisun City",
            "Vacaville",
            "Vallejo"
        ]
    },
    {
        county: "Calaveras",
        state: "CA",
        color: "bg-teal-400",
        glow: "shadow-teal-400/20",
        text: "text-teal-100",
        cities: [
            "Arnold"
        ]
    },
    {
        county: "Collin (Texas)",
        state: "TX",
        color: "bg-cyan-500",
        glow: "shadow-cyan-500/20",
        text: "text-cyan-200",
        cities: [
            "McKinney"
        ]
    },
    {
        county: "Denton (Texas)",
        state: "TX",
        color: "bg-teal-500",
        glow: "shadow-teal-500/20",
        text: "text-teal-200",
        cities: [
            "Frisco"
        ]
    }
    */
];

/**
 * Get total number of supported jurisdictions (cities)
 * @returns {number}
 */
export const getTotalJurisdictions = () => {
    return JURISDICTION_GROUPS.reduce((total, group) => total + group.cities.length, 0);
};

/**
 * Get a flat list of all supported cities
 * @returns {string[]}
 */
export const ALL_SUPPORTED_CITIES = JURISDICTION_GROUPS.flatMap(group => group.cities);

/**
 * Get cities grouped by county for display (alias for JURISDICTION_GROUPS if needed)
 */
export const getJurisdictionGroups = () => JURISDICTION_GROUPS;
